export default __webpack_public_path__ + "static/kr-b43634d479b76deaae8e6ac26c6c1697.svg";